import { TreeType } from '../markdown.types';
import { IRender } from './parseTreeToHtml.types';
import { boldAndItalicRender } from './renders/boldAndItalicRender';
import { boldRender } from './renders/boldRender';
import { italicRender } from './renders/italicRender';
import { linkRender } from './renders/linkRender';
import { strikethroughRender } from './renders/strikethroughRender';
import { textRender } from './renders/textRender';
import { underlineRender } from './renders/underlineRender';

const tagRenders: Record<string, IRender> = {
  keyWord: textRender,
  email: textRender,
  text: textRender,
  link: textRender,
  '@': textRender,
  '/': textRender,
  '```': textRender,
  ']': linkRender,
  '[': linkRender,
  '***': boldAndItalicRender,
  '**': boldRender,
  '*': italicRender,
  '~~': strikethroughRender,
  __: underlineRender,
};

export const parseTreeToHtml = (tree: TreeType): string => {
  return tree.reduce((acc, treeItem) => {
    const content = Array.isArray(treeItem.content)
      ? parseTreeToHtml(treeItem.content)
      : treeItem.content;

    const render = tagRenders[treeItem.tag] || textRender;
    return acc + render(content, treeItem.props);
  }, '');
};
